export default __webpack_public_path__ + "static/avocat-cour-petites-creances-scaled-df3a6bcf34de034193f0669644413191.jpg";